// extracted by mini-css-extract-plugin
export var acceptButton = "_2c-5";
export var fullContent = "_2c-4";
export var link = "_2c-6";
export var linkIcon = "_2c-7";
export var sideContent = "_2c-3";
export var sideImage = "_2c-2";
export var sideImageWrapper = "_2c-1";
export var splitLayout = "_2c-0";